import script from "./WatchLinkAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./WatchLinkAdd.vue?vue&type=script&setup=true&lang=js"

import "./WatchLinkAdd.vue?vue&type=style&index=0&id=1acfc70b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1acfc70b"]])

export default __exports__